import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppText } from './AppText';

type LoadingViewProps = {
  message?: string;
};

export function LoadingView({ message = '加载中' }: LoadingViewProps) {
  return (
    <View style={styles.container}>
      <ActivityIndicator color={tokens.colors.primary} />
      <AppText tone="muted" style={styles.message}>
        {message}
      </AppText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacing.xxl,
  },
  message: {
    marginTop: tokens.spacing.md,
  },
});
